export default __webpack_public_path__ + "static/media/product2.2de2d487.jpg";